import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import './style/index.less';

/**
 * 不同类型切换组件
 */
class SwitchTab extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    style: PropTypes.object,
    iconType: PropTypes.array,
    antd: PropTypes.bool,
    onSwitch: PropTypes.func
  };

  static defaultProps = {
    type: '0',

    style: { width: '83px', height: '33px', fontSize: '12px' },
    antd: true,
    iconType: ['thumb', 'list'],
  };

  constructor(props) {
    super(props);
    this.state = {
      type: this.props.type, // 0缩略图, 1列表，
    }
  }

  onSwitchTabAction = (e, type) => {
    this.setState({
      type
    });
    this.props.onSwitch(type);
  }

  render() {
    const { iconType, antd, onSwitch, ...otherProps } = this.props;
    let { type } = this.state;
    return (
      <div className="switchtab-body" {...otherProps}>
        <div title={window.language['material.grapMode']} className={`switchtab-body-left ${type === '0' ? 'switchtab-check' : ''}`} onClick={(e) => { this.onSwitchTabAction(e, '0') }}>
          <Icon className={`${iconType[0]} ${type === '0' ? 'switchtab-icon-check' : ''}`} /> 
        </div>
        <div title={window.language['material.listMode']} className={`switchtab-body-right ${type === '1' ? 'switchtab-check' : ''}`} onClick={(e) => { this.onSwitchTabAction(e, '1') }}>
          <Icon className={`${iconType[1]} ${type === '1' ? 'switchtab-icon-check' : ''}`} /> 
        </div>
      </div>
    );
  }
}

export default SwitchTab;



// WEBPACK FOOTER //
// ./src/components/SwitchTab/SwitchTab.js